import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPage } from '../utils/analytics'; 
import { getPageTitle } from '../utils/pageTitle';

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Title first, so the pageview below records the new page's title.
    document.title = getPageTitle(location.pathname); // WCAG 2.4.2: a distinct title per page
    trackPage(location.pathname); // Fire GA pageview on route change
  }, [location]);

  return null;
};

export default RouteTracker;
